var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeOff = function SvgEyeOff(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5421 11.1168C11.3362 11.3378 11.0878 11.5151 10.8118 11.6381C10.5358 11.7611 10.2378 11.8272 9.93572 11.8325C9.63361 11.8379 9.33352 11.7823 9.05336 11.6691C8.77319 11.556 8.51869 11.3875 8.30503 11.1739C8.09138 10.9602 7.92294 10.7057 7.80978 10.4255C7.69662 10.1454 7.64104 9.84529 7.64637 9.54318C7.6517 9.24108 7.71783 8.94314 7.84081 8.66714C7.96378 8.39114 8.14109 8.14274 8.36215 7.93675M14.4071 13.9818C13.1251 14.959 11.564 15.5004 9.95215 15.5268C4.70215 15.5268 1.70215 9.52675 1.70215 9.52675C2.63507 7.78817 3.929 6.26921 5.49715 5.07175L14.4071 13.9818ZM8.37715 3.70675C8.8934 3.58591 9.42195 3.52551 9.95215 3.52675C15.2021 3.52675 18.2021 9.52675 18.2021 9.52675C17.7469 10.3785 17.2039 11.1803 16.5821 11.9193L8.37715 3.70675Z",
    stroke: "#6280DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70215 1.27673L18.2021 17.7767",
    stroke: "#6280DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.952148 0.526733)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-off.61177ac7.svg";
export { ForwardRef as ReactComponent };